import React from 'react';

import { Button, Result } from 'antd';

import AppLayout from '../../Components/Common/Layout';

export function Error403() {
  return (
    <AppLayout>
      <Result status="403" title="" subTitle="Sorry, you are not authorized to access this page." />
    </AppLayout>
  );
}
